export function initItemcardNavigation() {
    const nav = document.querySelector(".itemcardNavigation");
    if (!nav) {
        return;
    }

    const items = [...nav.querySelectorAll("li")];

    for (const item of items) {
        const link = item.querySelector("a[href^='#']");
        const target = link ? document.querySelector(link.getAttribute("href")) : null;
        if (!target || target.children.length === 0) {
            item.remove();
        }
    }

    const links = [...nav.querySelectorAll("a[href^='#']")];

    const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            if (!entry.isIntersecting) {
                continue;
            }
            const link = nav.querySelector(`a[href="#${entry.target.id}"]`);
            if (!link) {
                continue;
            }
            links.forEach(l => l.classList.remove("is-active"));
            link.classList.add("is-active");
        }
    }, {rootMargin: "-20% 0px -75% 0px"});

    for (const link of links) {
        const target = document.querySelector(link.getAttribute("href"));
        if (target) {
            observer.observe(target);
        }
    }
}
